import { apiClient, ApiResponse } from './client'
import type { CenterInfoResponse, CenterUpdateRequest } from '@/types/center'

export const centerApi = {
  get: () =>
    apiClient.get<ApiResponse<CenterInfoResponse>>('/lc/admin/center'),
  update: (data: CenterUpdateRequest) =>
    apiClient.put<ApiResponse<CenterInfoResponse>>('/lc/admin/center', data),
}
